export default import.meta.ROLLUP_FILE_URL_ho5UR6eOWov5bnCJC$2MkA